import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLogoutMutation } from '../../Api/authentication';
import { useGlobalState } from '../../App/globalState';
import { ReactComponent as ArmenianFlag } from '../../Assets/armenian-flag.svg';
import { ReactComponent as HeaderLogo } from '../../Assets/logo2.svg';
import { ReactComponent as UKFlag } from '../../Assets/UK-flag.svg';

import useLogout from '../../Hooks/useLogout';
import useTranslate from '../../Hooks/useTranslate';
import Avatar from '../../Style-guide/Avatar';
import Button from '../../Style-guide/Button';
import Dropdown from '../../Style-guide/Dropdown';
import Modal from '../../Style-guide/Modal';
import Text from '../../Style-guide/Text';
import HeaderWrapper from './style/headerWrapper';

const Header = () => {
  const { globalState, updateGlobalState } = useGlobalState();
  const logout = useLogout();
  const [showModal, setShowModal] = useState(false);
  const { mutate: logoutRequest } = useLogoutMutation();
  const location = useLocation();
  const tr = useTranslate();
  const { language } = globalState || {};

  const { lastName } = globalState.user || {};
  const isLoggedIn = !!globalState?.user?.id;
  const isAuthPage = ['/signin', '/signup'].includes(location.pathname);

  const handleLanguageChange = () =>
    updateGlobalState({
      language: language === 'en' ? 'hy' : 'en',
    });

  const userIcon = (
    <Dropdown
      className='profile-dropdown'
      parent={<Avatar lastName={lastName} />}
      items={[
        <Link className='edit-btn' to='/profile'>
          <Text size='SM'>{tr('my_profile')}</Text>
        </Link>,
        <Link className='reservations-btn' to='/my-reservations'>
          <Text size='SM'>{tr('my_reservations')}</Text>
        </Link>,
        <Button className='logout-btn' onClick={() => setShowModal(true)}>
          <Text size='SM'>{tr('log_out')}</Text>
        </Button>,
      ]}
    />
  );

  const authButtons = (
    <nav className='header-navigation-buttons-container'>
      <Link to='/signup' className='link-btn sign-up-btn'>
        <Button>{tr('sign_up')}</Button>
      </Link>
      <Link to='/signin' className='link-btn'>
        <Button>{tr('sign_in')}</Button>
      </Link>
    </nav>
  );

  return (
    <>
      <HeaderWrapper $language={language}>
        <Link to='/' className='header-logo'>
          <HeaderLogo />
        </Link>

        <div className='right-side-container'>
          <Button
            type='icon'
            className={`language-flag-icon-btn ${language === 'en' ? 'spin' : ''}`}
            onClick={handleLanguageChange}
            icon={language === 'en' ? <UKFlag /> : <ArmenianFlag />}
          />

          {isLoggedIn && userIcon}
          {!isLoggedIn && !isAuthPage && authButtons}
        </div>
      </HeaderWrapper>

      <Modal
        show={showModal}
        onClose={() => setShowModal(false)}
        confirmation
        question={tr('are_you_sure')}
        confirmText={tr('log_out')}
        cancelText={tr('cancel')}
        onConfirm={() =>
          logout({
            redirectPath: '/signin',
            logoutRequest,
            globalStateKey: 'user',
          })
        }
      />
    </>
  );
};

export default Header;
